// import Vue from "vue";
// import store from "@/store";
// import * as KEYS from '@/store/storeKeys'

export default function Initializer() {
    // store[KEYS.SECRET] = Vue.ls.get(KEYS.SECRET, '')
}
